export default function CardError({ error }) {
  return error ? <p className="text-sm  text-red-500 pt-2">{error}</p> : "";
}
